export default function muiComma(x) {
  if (x !== null && x !== undefined) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return ""; // or handle the case when x is null or undefined
}
